import { bugReportApiFetch } from "@/components/common/bugReportClient";

export async function devNotesReview(
  token: string,
  body: {
    id: string;
    action: "approve" | "alter" | "deny" | "reopen";
    effective_body?: string;
    reviewer_note?: string;
    include_asset_in_sync?: boolean;
  },
) {
  return bugReportApiFetch("/api/dev-notes/review", "POST", token, body);
}

export async function devNotesUpdate(
  token: string,
  body: {
    id: string;
    body?: string;
    placement?: { repo_path: string; component_hint?: string; usage_hint?: string };
    include_asset_in_sync?: boolean;
  },
) {
  return bugReportApiFetch("/api/dev-notes/update", "POST", token, body);
}

export async function devNotesAssetUpload(
  token: string,
  body: {
    id: string;
    content_base64: string;
    content_type: string;
    placement?: { repo_path: string; component_hint?: string; usage_hint?: string };
  },
) {
  return bugReportApiFetch("/api/dev-notes/asset-upload", "POST", token, body);
}

export async function devNotesAssetDelete(token: string, body: { id: string }) {
  return bugReportApiFetch("/api/dev-notes/asset-delete", "POST", token, body);
}

// Close out a dev-sync queue item directly from the UI. Mirrors the delete
// semantics of `sync-complete` (row is removed, linked bug_reports row is
// resolved if present) but is JWT-authed for owners/devs shipping work
// outside of the IDE agent path. See docs/runbooks/dev_sync_and_fix.md §8.
export async function devNotesClose(
  token: string,
  body: { id: string; resolution_ref?: string; reason?: string },
) {
  return bugReportApiFetch<{
    ok: true;
    deleted_id: string;
    resolution_ref: string | null;
    reason: string | null;
    bug_report_resolved: boolean;
    closed_by_user_id: string;
  }>("/api/dev-notes/close", "POST", token, body);
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("Failed to read file"));
        return;
      }
      const base64 = result.includes(",") ? result.split(",")[1]! : result;
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error ?? new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
}
